
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nosotros/politica-de-privacidad",
      function () {
        return require("private-next-pages/nosotros/politica-de-privacidad.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nosotros/politica-de-privacidad"])
      });
    }
  